import { Box } from '@chakra-ui/react';
import { useForm, Form } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import HeaderMobile from 'Component/header-mobile';
import { Condition } from 'Component/others';
import useGetTotalRequestReschedule from 'Domain/reschedule/useGetTotalRequestReschedule';
import useGetHostScheduleDetail from 'Domain/host/useGetHostScheduleDetail';
import useGetRescheduleTypeList from 'Domain/reschedule/useGetRescheduleTypeList';

import Head from 'View/reschedule-form/section/head';
import ApprovalType from 'View/reschedule-form/section/approval-type';
import ChangeHost from 'View/reschedule-form/section/change-host';
import ChangeSchedule from 'View/reschedule-form/section/change-schedule';
import Reason from 'View/reschedule-form/section/reason';
import UploadImage from 'View/reschedule-form/section/upload-image';
import ActionButton from 'View/reschedule-form/section/action-button';
import { defaultValuesForm } from 'View/reschedule-form/const';

import styles from './styles.module.css';
import checkAvailableToApprovalRequest from './helper/checkAvailableToApprovalRequest';

const RescheduleForm = () => {
  const { t } = useTranslation('host-reschedule');
  const navigate = useNavigate();
  const form = useForm({ defaultValues: defaultValuesForm });
  const { data: dataTotalRequest, isLoading } = useGetTotalRequestReschedule();
  const { data: scheduleDetail, isFetching: isLoadingScheduleDetail } = useGetHostScheduleDetail();
  const { data: approvalTypeOptions, isFetching: isFetchingList } = useGetRescheduleTypeList();

  const { control, watch } = form;
  const { approvalType } = watch();

  const isChangeScheduleAvailable = approvalTypeOptions?.[0].isAvailable;
  const isApprovalTypeChangeSchedule = approvalType?.value === 1;
  const isCanApprovalRequest = checkAvailableToApprovalRequest({ approvalType, dataTotalRequest, isLoading, isChangeScheduleAvailable });
  const isHasRescheduleProgress = scheduleDetail?.reschedule?.statusProgress === 'Diproses';

  useEffect(() => {
    if (isHasRescheduleProgress) navigate('/');
    // eslint-disable-next-line
  }, [isHasRescheduleProgress]);

  return (
    <Box className={styles['reschedule-form__container']}>
      <HeaderMobile type="header-back" title={t('title')} />
      <Head isLoadingScheduleDetail={isLoadingScheduleDetail} scheduleDetail={scheduleDetail} />
      <Form control={control} className={styles['reschedule-form__form--container']}>
        <ApprovalType
          form={form}
          approvalTypeOptions={approvalTypeOptions}
          isFetchingList={isFetchingList}
          isChangeScheduleAvailable={isChangeScheduleAvailable}
        />

        <Condition statement={isCanApprovalRequest}>
          <Condition statement={isApprovalTypeChangeSchedule}>
            <ChangeSchedule form={form} />
          </Condition>

          <Condition statement={!isApprovalTypeChangeSchedule}>
            <ChangeHost form={form} />
          </Condition>

          <Reason form={form} />

          <UploadImage form={form} />

          <ActionButton form={form} />
        </Condition>
      </Form>
    </Box>
  );
};

export default RescheduleForm;
